import Link from 'next/link'

const Button = ({
    name,
    link,
    ...args
}) => {
  const base = 'relative w-fit text-body2Mobile md:text-body2Desktop text-umber font-chivoMono custom-underline transition-all duration-500'

  return (
    <Link
      scroll={false}
      href={link}
      {...args}
      className={base}
    >
      {name}
    </Link>
  )
}

export default Button
